export default "__VITE_ASSET__DUuLuASC__"